import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { type economicStatusAndOccupation, type EmployeeInfo, type OrganizationInfo } from 'types/pages';

interface EmployeeState {
    organizationInfo: OrganizationInfo | null;
    employeeInfo: EmployeeInfo[];
    onboardedEmails: string[];
    economicStatusAndOccupation: economicStatusAndOccupation[];
}

const initialState: EmployeeState = {
    organizationInfo: null,
    employeeInfo: [],
    onboardedEmails: [],
    economicStatusAndOccupation: [],
};

const employeeSlice = createSlice({
    name: 'employee',
    initialState,
    reducers: {
        setOrganizationInfo: (state, { payload }: PayloadAction<OrganizationInfo | null>) => ({
            ...state,
            organizationInfo: payload,
        }),
        setEmployeeInfo: (state, { payload }: PayloadAction<EmployeeInfo[]>) => ({
            ...state,
            employeeInfo: payload,
        }),
        setOnboardedEmail: (state, { payload }: PayloadAction<string[]>) => ({
            ...state,
            onboardedEmails: payload,
        }),
        setEconomicStatusAndOccupation: (state, { payload }: PayloadAction<economicStatusAndOccupation[]>) => ({
            ...state,
            economicStatusAndOccupation: payload,
        }),

    },
});

export const { setOrganizationInfo, setEmployeeInfo, setOnboardedEmail, setEconomicStatusAndOccupation } = employeeSlice.actions;

export default employeeSlice.reducer;
